export const partAttributesTypes = {
  RANGE: 0,
  SELECT: 1,
  DATEPICKER: 2,
  NESTED: 3,
  KDEYWORD_SEARCH: 4,
  TEXT: 5,
  USER_ATTR: 6,
};
